<template>
	<el-dropdown @command="handleLanguageChange">
		<span class="el-dropdown-link">
			{{ currentLabel }} <i class="el-icon-arrow-down el-icon--right"></i>
		</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item v-for="item in langOptions" :key="item.value" :command="item"
				:class="{ 'is-active': currentValue === item.lang }">
				{{ item.name }}
			</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
</template>

<script>
import { mapState } from "vuex";

export default {
	computed: {
		...mapState(["config"]),
		// 获取配置中的语言列表
		langOptions() {
			return this.config?.langList || [];
		},
		// 获取当前显示的文字
		currentLabel() {
			const active = this.langOptions.find(opt => opt.lang === this.currentValue);
			return active ? active.name : this.$t('选择语言');
		},
		// 从 i18n 实例获取当前值，保证响应式
		currentValue() {
			return this.$i18n.locale;
		}
	},
	methods: {
		handleLanguageChange(item) {
			console.log(item);
			// 1. 切换 i18n 实例的语言
			this.$i18n.locale = item.lang;
			// 2. 建议：存储到 localStorage，防止刷新页面丢失
			localStorage.setItem('defaultLang', item.lang)
			this.$message.success(`${this.$t('选择语言')}${item.name}`);
		},
	}
};
</script>

<style lang="scss" scoped>
.el-dropdown-link {
	cursor: pointer;
}

/* 选中项的高亮样式 */
.is-active {
	color: #409EFF !important;
	background-color: #ecf5ff !important;
	font-weight: bold;
}
</style>
